import CustomMenu from 'components/Menu';
import React from 'react';
import { BsChevronDown } from 'react-icons/bs';

const GameCard = ({
    title,
    description,
    date,
    start,
    end,
    total_sales,
    total_points,
    total_players,
    status = "Ongoing",
    onViewMore,
    onMenuItemClick,
    avatar = null, // Placeholder for avatar image
}) => {
    return (
        <div className="mx-auto border w-full rounded-2xl p-4 shadow-sm bg-white">
            <div className="flex items-start justify-between">
                {/* Left section with image and text */}
                <div className="flex items-start gap-4">
                    {/* Placeholder image */}
                    <div className="w-12 h-12 rounded-md bg-gray-100 flex items-center justify-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-6 h-6 text-gray-400"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4z" />
                        </svg>
                    </div>

                    {/* Title and Description */}
                    <div>
                        <h2 className="font-semibold text-lg text-gray-800">{title}</h2>
                        <p className="text-sm text-gray-500">{description}</p>
                    </div>
                </div>

                {/* Buttons */}
                <div className="flex items-center gap-2">
                    <span className="border border-blue-500 text-blue-500 text-sm px-3 py-2 rounded bg-blue-100 ">{status}</span>
                    <button
                        className="bg-blue-600 text-white text-sm px-4 py-1 rounded-lg flex items-center gap-2"
                        onClick={onViewMore}
                    >
                        <CustomMenu
                            buttonLabel='View more'
                            buttonProps={{ style: { color: 'white' } }}
                            onMenuItemClick={onMenuItemClick}
                            menuItems={['Leaderboard', 'Participation', 'Merchants', 'Prizes']} /> <BsChevronDown />
                    </button>
                </div>
            </div>

            <hr className="my-4" />

            {/* Details row */}
            <div className="grid grid-cols-6 gap-4 text-sm text-gray-700">
                <div>
                    <div className="text-gray-400">Date</div>
                    <div>{date}</div>
                </div>
                <div>
                    <div className="text-gray-400">Start</div>
                    <div>{start}</div>
                </div>
                <div>
                    <div className="text-gray-400">End</div>
                    <div>{end}</div>
                </div>
                <div>
                    <div className="text-gray-400">Total sales</div>
                    <div>{total_sales}</div>
                </div>
                <div>
                    <div className="text-gray-400">Total points</div>
                    <div>{total_points}</div>
                </div>
                <div>
                    <div className="text-gray-400">Total players</div>
                    <div>{total_players}</div>
                </div>
            </div>
        </div>
    );
};

export default GameCard;
